"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _formik = require("formik");

var _excluded = ["id", "name", "question", "options", "subQuestionInfo", "checkBoxes", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CHUICheckBoxes = function CHUICheckBoxes(_ref) {
  var id = _ref.id,
      name = _ref.name,
      question = _ref.question,
      options = _ref.options,
      subQuestionInfo = _ref.subQuestionInfo,
      checkBoxes = _ref.checkBoxes,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var formik = (0, _formik.useFormikContext)();

  var handleChange = function handleChange(event, isChecked) {
    if (isChecked) {
      var array = new Array();

      if (formik.values[name] != "") {
        array = formik.values[name];
      }

      array.push(event.target.value);
      formik.setFieldValue(name, array);
    } else {
      var _array = formik.values[name];

      var index = _array.indexOf(event.target.value);

      if (index > -1) {
        _array.splice(index, 1);
      }

      formik.setFieldValue(name, _array);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    className: className
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 11
  }, question != null && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h6",
    htmlFor: id,
    tabIndex: "0"
  }, question), subQuestionInfo != null && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    htmlFor: id,
    tabIndex: "0",
    sx: {
      fontSize: "18",
      fontWeight: "bold"
    }
  }, subQuestionInfo)), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 11
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, /*#__PURE__*/_react.default.createElement(_material.FormGroup, null, checkBoxes.map(function (choice) {
    return /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
      value: choice["value"],
      control: /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
        checked: formik.values[name] == null ? false : formik.values[name].includes(choice["value"]),
        "aria-label": "checkbox",
        tabIndex: "0",
        onChange: handleChange,
        name: name
      }),
      label: /*#__PURE__*/_react.default.createElement("span", {
        sx: {
          color: formik.errors[name] ? "#f44336" : null
        }
      }, choice["checkBoxLabel"]),
      tabIndex: "0"
    });
  })))), formik.errors[name] ? /*#__PURE__*/_react.default.createElement(_material.FormHelperText, {
    error: true,
    sx: {
      color: "#f44336"
    }
  }, formik.errors[name]) : null);
};

var _default = CHUICheckBoxes;
exports.default = _default;